import { Theme } from './config.types';

// it generates range of values with diff of 4 between them
const sizeGen =
  (base: number, start: number) =>
  (range: number): Array<number> =>
    [...Array(range)].reduce(
      (sum) => {
        sum[0] += base;
        sum[1].push(sum[0]);
        return sum;
      },
      [start, [start]],
    )[1];

const sizeGenWithBaseOf4 = sizeGen(4, 0);

export const theme: Theme = {
  sizes: {
    font: {
      x_small: 12,
      small: 14,
      base: 16,
      large: 24,
      x_large: 27,
    },
  },
  radii: sizeGenWithBaseOf4(25),
  fontSizes: sizeGenWithBaseOf4(20),
  lineHeights: sizeGenWithBaseOf4(20).map((size) => `${size}px`),
  space: sizeGenWithBaseOf4(20),
  lineHeight: {
    base: '26px',
  },
  fonts: {
    primary: 'Verdana_Regular',
    secondary: 'Beatrice_Regular',
  },
  screenSizes: [576, 768, 992, 1200, 1400],
  container: {
    width: {
      default: 'auto',
      screenSizes: [540, 720, 960, 1140, 1320],
    },
    margin: {
      default: 24,
      screenSizes: [24, 24, 32, 32, 32],
    },
  },
  grid: {
    gutter: {
      default: 16,
      screenSizes: [16, 16, 32, 32, 32],
    },
    column: {
      availableSizes: ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'],
      screenSizes: ['sm', 'md', 'lg', 'xl', 'xxl'],
    },
  },
};
